
<template>
  <div class="page-container">
    <AppHeader title="User Permissions"/>
    
    <div class="content-wrapper">
      <!-- Error Message -->
      <div v-if="showError" class="alert alert-danger text-center">
        {{ this.mainErrorMsg }}
      </div>

      <!-- Permissions View -->
      <div class="permissions-container">
        <div class="permissions-header">
          <h2>User Permissions for {{ user.user_name }}</h2>
        </div>

        <div class="modules-grid">
          <button 
            v-for="module in modules" 
            :key="module.id"
            class="module-btn"
            @click="showModulePermissions(module)"
          >
            {{ module.name }}
          </button>
        </div>

        <div v-if="modulePermissions.length > 0" class="permissions-area">
          <div class="permissions-actions">
            <button @click="toggleSelectAllPermissions()" class="btn btn-info btn-sm" style="background-color: var( --theme-accent); border: 1px ;">
              Select/Unselect All
            </button>
          </div>
          
          <div class="permissions-grid">
            <div 
              v-for="permission in modulePermissions" 
              :key="permission.id"
              class="permission-card"
              :class="{ 'active': currUserHasPermission(permission.id) }"
              @click="togglePermissionChecked(permission.id)"
            >
              <div class="custom-checkbox">
                <svg viewBox="0 0 24 24" class="checkmark">
                  <path fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <span class="permission-text">{{ permission.name }}</span>
            </div>
          </div>
          
          <div class="permissions-footer">
            <button class="btn btn-success btn-lg" @click="savePermission">Save Changes</button>
            <button class="btn btn-danger btn-lg" @click="goBack">Cancel</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices"
import AppHeader from "@/components/AppHeader";
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters({
            modules: "modules_options/modulesPers",
            userPermissions: "modules_options/userPermissions"
        })
    },
    mixins: [commonServices],
    mounted() {
        if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
            this.fetchUserData();
        } else {
            this.$router.push({ name: 'login' });
        }
        this.language = 'ar';
        this.logoImage = '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
    },
    components: { AppHeader },
    data: function () {
        return {
            modulePermissions: [],
            user: {},
            userId: null,
            userJson: {},
            userPerms: [],
            showError: false,
            logoImage: '',
            mainErrorMsg: '',
            logoUrl: '',
            language: 'en'
        }
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'users' });
        },
        fetchUserData() {
            this.userId = this.$route.params.userId;
            this.userJson.userId = this.userId;
            this.getUser();
            this.getUserPermissions();
        },
        async getUser() {
            this.userJson.appId = localStorage.appId;
            try {
                let dataURL = this.apiURL + 'Users/getAllUsers';
                let response = await axios.post(dataURL, this.userJson);
                if (response.data.status === 'success') {
                    let allUsers = response.data.results;
                    this.user = allUsers.find(u => u.id == this.userId) || {};
                }
            }
            catch (error) {
                console.log(error);
            }
        },
        async getUserPermissions() {
            try {
                let dataURL = this.apiURL + 'Modules/getUserPermissions';
                let response = await axios.post(dataURL, this.userJson);
                if (response.data.status === 'success') {
                    this.userPerms = response.data.results
                    this.modulePermissions = [];
                    this.userPerms.splice(0, 1);
                    if (this.modules && this.modules.length > 0) {
                        this.showModulePermissions(this.modules[0]);
                    }
                } else {
                    this.goBack();
                    this.showAlert("Error Happened Please Check Entered Data!");
                }
            }
            catch (error) {
                this.goBack();
                this.showAlert("Error Happened Please Check Entered Data!");
            }
        },
        currUserHasPermission: function (id) {
            let hasPermission = this.userPerms.find(user_permission => user_permission == id);
            return hasPermission ? true : false;
        },
        togglePermissionChecked: function (id) {
            let index = this.userPerms.findIndex(user_permission => user_permission == id);
            if (index > -1) {
                this.userPerms.splice(index, 1)
            } else {
                this.userPerms.push(id)
            }
        },
        showModulePermissions: function (module) {
            this.modulePermissions = module.options
        },
        toggleSelectAllPermissions: function () {
            let baseSubSet = this.modulePermissions.map(el => el.id)
            if (this.isSubset(baseSubSet, this.userPerms)) {
                this.userPerms = this.removeSubset(baseSubSet, this.userPerms);
            } else {
                this.userPerms = this.mergeArrays(baseSubSet, this.userPerms)
            }
        },
        mergeArrays: function (arr1, arr2) {
            const mergedArray = arr1.concat(arr2);
            const uniqueArray = [...new Set(mergedArray)];
            return uniqueArray;
        },
        removeSubset: function (subset, parent) {
            for (let i = 0; i < subset.length; i++) {
                const index = parent.indexOf(subset[i]);
                if (index !== -1) {
                    parent.splice(index, 1);
                }
            }
            return parent;
        },
        isSubset: function (subset, parent) {
            for (let i = 0; i < subset.length; i++) {
                if (parent.indexOf(subset[i]) === -1) {
                    return false;
                }
            }
            return true;
        },
        savePermission: async function () {
            this.userJson.userId = this.userId;
            this.userJson.appId = localStorage.appId;
            this.userJson.options = this.userPerms;
            try {
                let dataURL = this.apiURL + 'Modules/setUserPermissions';
                let response = await axios.post(dataURL, this.userJson);
                if (response.data.status === 'success') {
                    this.showSuccess("Successfully Updated Permissions")
                    if (this.userId == localStorage.userId) {
                        this.$store.dispatch('modules_options/fetchUserPermissions');
                    }
                    this.goBack();
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }
            }
            catch (error) {
                this.showAlert("Error Happened Please Check Entered Data!");
            }
        }
    }
}
</script>
<style scoped>
.page-container {
  min-height: 100vh;
  margin-top: -26px;
  background: var(--theme-bg-end);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(1px);
}

.content-wrapper {
  padding: 1rem;
  max-width: 1400px;
  margin: 0 auto;
}

/* Permissions Styles */
.permissions-container {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 2rem;
}

.permissions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 1rem;
}

.permissions-header h2 {
  color: var(--theme-text-main);
  margin: 0;
}

.modules-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
  justify-content: center;
}

.module-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1em;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 150px;
}

.module-btn:hover, .module-btn:focus {
  background: var(--theme-primary);
  transform: translateY(-2px);
}

.permissions-area {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 2rem;
}

.permissions-actions {
  margin-bottom: 2rem;
  text-align: right;
}

.permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 3rem;
}

.permission-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  position: relative;
  overflow: hidden;
}

.permission-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.permission-card.active {
  background: rgba(92, 107, 192, 0.2); 
  border-color: var(--theme-primary);
  box-shadow: 0 4px 12px rgba(92, 107, 192, 0.15);
}

.custom-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(0,0,0,0.1);
  flex-shrink: 0;
}

.permission-card.active .custom-checkbox {
  background: var(--theme-primary);
  border-color: var(--theme-primary);
  transform: scale(1.05);
}

.checkmark {
  width: 16px;
  height: 16px;
  color: white;
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.permission-card.active .checkmark {
  opacity: 1;
  transform: scale(1);
}

.permission-text {
  font-size: 1.3rem;
  color: var(--theme-text-muted);
  font-weight: 500;
  transition: color 0.3s;
  line-height: 1.4;
}

.permission-card.active .permission-text {
  color: #fff;
}

.permissions-footer {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 2rem;
}

.permissions-footer .btn {
  min-width: 150px;
}
</style>

